module.exports = __webpack_public_path__ + "static/media/truck2000.b3fc1e24.svg";